import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanMatch {
  constructor(private auth: AuthService, private router: Router) {}

  private decide(targetUrl: string, allowedRoles: string[] = []): Observable<boolean | UrlTree> {
    return this.auth.isAuthenticated$.pipe(
      take(1),
      map(ok => {
        if (!ok) {
          return this.router.createUrlTree(['/auth'], { queryParams: { r: targetUrl || '/imoveis' } });
        }

        if (allowedRoles.length && !allowedRoles.some(role => this.auth.hasRole(role))) {
          return this.router.createUrlTree(['/imoveis']);
        }

        return true;
      })
    );
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.decide(state.url, route.data?.['roles'] ?? []);
  }

  canMatch(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    const url = '/' + segments.map(s => s.path).join('/');
    return this.decide(url || '/imoveis', route.data?.['roles'] ?? []);
  }
}
